(() => {
  if (window.__moldeaSizeGuideLoaded) return;
  window.__moldeaSizeGuideLoaded = true;

  const rootOf = (el) => el && el.closest('[data-moldea-fys]');
  let lastFocus = null;

  function openGuide(root, trigger) {
    if (!root) return;
    const overlay = root.querySelector('[data-fys-overlay]');
    if (!overlay) return;
    lastFocus = trigger || document.activeElement;
    overlay.hidden = false;
    trigger?.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    setTimeout(() => root.querySelector('[data-fys-close]')?.focus(), 0);
  }

  function closeGuide(root) {
    if (!root) return;
    const overlay = root.querySelector('[data-fys-overlay]');
    if (!overlay) return;
    overlay.hidden = true;
    root.querySelector('[data-fys-open]')?.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    lastFocus?.focus?.();
  }

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-fys-open]');
    if (open) {
      e.preventDefault();
      openGuide(rootOf(open), open);
      return;
    }
    const close = e.target.closest('[data-fys-close]');
    if (close) {
      e.preventDefault();
      closeGuide(rootOf(close));
      return;
    }
    const overlay = e.target.closest('[data-fys-overlay]');
    if (overlay && e.target === overlay) closeGuide(rootOf(overlay));
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const overlay = document.querySelector('[data-fys-overlay]:not([hidden])');
    if (overlay) closeGuide(rootOf(overlay));
  });
})();